import React from 'react';
import PropTypes from 'prop-types';
import {createIntl, createIntlCache, FormattedMessage, defineMessages} from 'react-intl';

import FilterField from './FilterField';
import FilterFieldMobile from './FilterField/Mobile';
import SearchAutocomplete from "../../SearchAutocomplete";

import filterUtil from '../../utils/filter';
import Config from '../../utils/config';
import {getCurrentTranslation} from '../../utils/translations.js';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import classnames from "classnames";
import RecommendationsCard from "../../Recommendation/RecommendationsCard";
import RecommendationsLabel from "../../Recommendation/RecomendationsLabel";

const messages = defineMessages({
    filter_activity_filter_class_label: {id: 'filter_activity_filter_class_label', defaultMessage: 'Ročník'},
    filter_activity_filter_class_under: {id: 'filter_activity_filter_class_under', defaultMessage: 'Zvolte ročník'},
    filter_activity_filter_level_label: {id: 'filter_activity_filter_level_label', defaultMessage: 'Úroveň'},
    filter_activity_filter_level_under: {id: 'filter_activity_filter_level_under', defaultMessage: 'Zvolte úroveň'},
    filter_activity_filter_topic_label: {id: 'filter_activity_filter_topic_label', defaultMessage: 'Téma'},
    filter_activity_filter_topic_under: {id: 'filter_activity_filter_topic_under', defaultMessage: 'Zvolte téma'},
    filter_activity_filter_subtopic_label: {id: 'filter_activity_filter_subtopic_label', defaultMessage: 'Podtéma'},
    filter_activity_filter_subtopic_under: {
        id: 'filter_activity_filter_subtopic_under',
        defaultMessage: 'Zvolte podtéma'
    },
});

var cache;
var intl;

class Filter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openFilter: false,
            openFilterSearch: false
        }

        cache = createIntlCache();
        intl = createIntl({locale: Config.get('locale'), messages: getCurrentTranslation(Config.get('locale'))}, cache);
    }

    componentDidUpdate(prevProps, prevState) {
        const {prevFilters} = prevProps;
        if (!prevFilters) {
            return;
        }

        const {prevSubtopic} = prevFilters;
        const {filters} = this.props;
        const {subtopic} = filters;

        if (subtopic && subtopic.items.length > 0 && (!prevSubtopic || prevSubtopic.items.length === 0)) {
            const $ = window.$;
            $('[data-toggle="collapse"]').collapse();
        }
    }

    render() {
        const {filters, choiceCallback, gradeType, recommendationAcitivities, colourTheme} = this.props;
        const {grade, topic, subtopic} = filters;

        let filterStepNumber = subtopic && subtopic.selected ?
            3 :
            topic && topic.selected ?
                2 :
                grade && grade.selected ?
                    1 : 0;

        const gradeItem = grade && grade.selected && (grade.selected.name && grade.selected || filterUtil.findFilterByLabelId(grade.items, grade.selected));
        const topicItem = topic && topic.selected && (topic.selected.name && topic.selected || filterUtil.findFilterByLabelId(topic.items, topic.selected));
        const subtopicItem = subtopic && subtopic.selected && (subtopic.selected.name && subtopic.selected || filterUtil.findFilterByLabelId(subtopic.items, subtopic.selected));

        if (typeof gradeItem === "undefined") {
            filterStepNumber++;
        }

        const firstStepName = intl.formatMessage(gradeType === 'languages' ? messages.filter_activity_filter_level_label : messages.filter_activity_filter_class_label);
        const firstStepAction = intl.formatMessage(gradeType === 'languages' ? messages.filter_activity_filter_level_under : messages.filter_activity_filter_class_under);
        const topicName = intl.formatMessage(messages.filter_activity_filter_topic_label);
        const topicAction = intl.formatMessage(messages.filter_activity_filter_topic_under);
        const subtopicName = intl.formatMessage(messages.filter_activity_filter_subtopic_label);
        const subtopicAction = intl.formatMessage(messages.filter_activity_filter_subtopic_under);

        return (
            <section className="section section--full py-0">
                <Modal isOpen={this.state.openFilter}
                       className="filter__lightbox"
                       toggle={() => this.setState({openFilter: false})}>
                    <ModalHeader toggle={() => this.setState({openFilter: false})} className="filter__lightbox">
                        <h2><FormattedMessage id='filter_activity_filter_h2' defaultMessage='Filtr cvičení'/></h2>
                    </ModalHeader>
                    <div className="mx-auto filter__lightbox">

                        <form>
                            {typeof gradeItem !== 'undefined' &&
                                <FilterFieldMobile id="rocnik" name={firstStepName} filterOptions={grade && grade.items}
                                                   filterKey="grade" choiceCallback={choiceCallback}
                                                   selected={(grade && grade.selected) || ''}
                                                   emptyText={firstStepAction}
                                                   disabled={false}/>
                            }
                            <FilterFieldMobile id="tema"
                                               name="Téma" filterOptions={topic && topic.items}
                                               filterKey="topic" choiceCallback={choiceCallback}
                                               selected={(topic && topic.selected) || ''}
                                               filterStepNumber={filterStepNumber}
                                               emptyText={topicAction} disabled={filterStepNumber < 1 || !topic || !topic.items.length}/>

                            <FilterFieldMobile id="podtema"
                                               name="Podtéma" filterOptions={subtopic && subtopic.items}
                                               filterKey="subtopic" choiceCallback={choiceCallback}
                                               selected={(subtopic && subtopic.selected) || ''}
                                               filterStepNumber={filterStepNumber}
                                               emptyText={subtopicAction} disabled={filterStepNumber < 2}/>

                            <button type="submit" className="btn btn-brick btn-sm text-white" onClick={(e) => {
                                e.preventDefault();
                                window.collapseFilterMobile();
                                this.setState({openFilter: false});
                            }}>
                                <FormattedMessage id='filter_activity_filter_button_show'
                                                  defaultMessage='Zobrazit'/>
                            </button>
                        </form>
                    </div>
                </Modal>

                <div className="filter" id="filter">
                    <div className="filter__tip hidden">
                        <h3><FormattedMessage id='filter_activity_filter_tip_h3' defaultMessage='TIP'/></h3>
                        <p>
                            <FormattedMessage id='filter_activity_filter_tip_text'
                                              defaultMessage='Abys našel to správné cvičení, můžeš vždy použít filtr podle ročníku nebo tématu...'/>
                        </p>
                        <p>
                            <a href="#" className="btn btn-mini btn-brick"><FormattedMessage
                                id='filter_activity_filter_tip_link' defaultMessage='OK'/></a>
                        </p>
                    </div>

                    <div className="filter__main">
                        <div className={classnames("filter__in", {"filter__in__no_rec": !recommendationAcitivities || !recommendationAcitivities.length})}>
                            <div
                                className={classnames('filter__search profile-filter', {'full-width': this.state.openFilterSearch})}>
                                {!this.state.openFilterSearch && <a className="filter__label d-none d-xl-inline-block" href="javascript:;"
                                                                    onClick={() => this.setState({openFilterSearch: true})}>
                                    <FormattedMessage defaultMessage='Vyhledat'/>
                                </a>}
                                <div className={classnames('w-100 h-100', {'d-xl-block': this.state.openFilterSearch, 'd-xl-none': !this.state.openFilterSearch})}><SearchAutocomplete filter /></div>
                                {this.state.openFilterSearch &&
                                    <a className="btn btn-close"
                                       onClick={() => this.setState({openFilterSearch: false})}/>
                                }
                            </div>

                            <div className={classnames('filter__select', {'d-xl-none': this.state.openFilterSearch})}>
                                <a className="filter__label" href="javascript:;"
                                   onClick={() => this.setState({openFilter: true})}>
                                    <FormattedMessage id='filter_activity_filter_trainning_do'
                                                      defaultMessage='Filtr cvičení'/>
                                </a>
                                <ul className="filter__options">
                                    {typeof gradeItem !== 'undefined' &&
                                        <li>
                                            <a href="#rocnik" data-bs-toggle="collapse" className="filter__option">
                                                {gradeItem &&
                                                    <span>
                                                        {gradeItem.name}
                                                    </span>
                                                }
                                                {!gradeItem &&
                                                    <span>
                                                        {firstStepAction}
                                                    </span>
                                                }
                                            </a>
                                        </li>
                                    }
                                    <li>
                                        <a href="#tema" data-bs-toggle="collapse"
                                           className={"filter__option" + (filterStepNumber < 1 || !topic || !topic.items.length ? " disabled" : "")}>
                                            {topicItem &&
                                                <span>
                                                    {topicItem.name}
                                                </span>
                                            }
                                            {!topicItem &&
                                                <span><FormattedMessage id='filter_activity_filter_trainning_topic'
                                                                        defaultMessage='Zvolte téma'/></span>
                                            }
                                        </a>
                                    </li>
                                    {subtopic && subtopic.items.length > 0 &&
                                        <li>
                                            <a href="#podtema" data-bs-toggle="collapse"
                                               className={"filter__option" + (filterStepNumber < 2 ? " disabled" : "")}>
                                                {subtopicItem &&
                                                    <span>
                                                        {subtopicItem.name}
                                                    </span>
                                                }
                                                {!subtopicItem &&
                                                    <span><FormattedMessage
                                                        id='filter_activity_filter_trainning_subtopic'
                                                        defaultMessage='Zvolte podtéma'/></span>
                                                }
                                            </a>
                                        </li>
                                    }
                                </ul>
                            </div>

                            {recommendationAcitivities && recommendationAcitivities.length > 0 &&
                                <div className={'filter__recommendation position-relative'}>
                                    <RecommendationsLabel recommendationActivities={recommendationAcitivities}
                                                          colourTheme={colourTheme}/>
                                    <RecommendationsCard recommendationActivities={recommendationAcitivities}
                                                         colourTheme={colourTheme}/>

                                </div>
                            }
                        </div>
                    </div>

                    <FilterField id="rocnik" name={firstStepName} filterOptions={grade && grade.items} filterKey="grade"
                                 choiceCallback={choiceCallback}/>
                    <FilterField id="tema" name={topicName} filterOptions={topic && topic.items} filterKey="topic"
                                 choiceCallback={choiceCallback}/>
                    <FilterField id="podtema" name={subtopicName} filterOptions={subtopic && subtopic.items}
                                 filterKey="subtopic" choiceCallback={choiceCallback}/>
                </div>

            </section>
        );
    }
}

const filterShape = PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        slug: PropTypes.string,
    })),
    selected: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.object
    ]),
});

Filter.propTypes = {
    filters: PropTypes.shape({
        grade: filterShape,
        topic: filterShape,
        subtopic: filterShape,
    }).isRequired,
    choiceCallback: PropTypes.func.isRequired,
    colourTheme: PropTypes.string,
};

export default Filter;
